import React from 'react';

import { useAccountsDropDownContext } from './AccountsDropDownContext';
import {
  AccountsDropDownEmpty,
} from './AccountsDropDownEmpty';
import {
  AccountsDropDownOption,
} from './AccountsDropDownOption';
import styles from './styles.pcss';

export interface AccountsDropDownGroupProps {
  readonly children?: any
  readonly name?: string
  // When its need prevent select account from this group
  readonly removedFromDOM?: boolean
}

export const AccountsDropDownGroup: React.FC<AccountsDropDownGroupProps> = ({
  children,
  name,
  removedFromDOM,
}) => {
  const {
    displayHidden,
    onSelect,
    setHasHidden,
  } = useAccountsDropDownContext();

  React.useEffect(
    () => {
      const childrenAsArray = React.Children.toArray(children);
      const matchHiddenAccount = childrenAsArray.find(
        (child) => (child as React.ReactElement).props.isHidden,
      );

      if (matchHiddenAccount) {
        setHasHidden(true);
      }
    },
    [children, setHasHidden],
  );

  if (removedFromDOM) return null;

  const cloned = React.Children.toArray(children)
    .filter((child) => {
      const childTyped = child as React.ReactElement;
      return displayHidden || !childTyped.props.isHidden;
    })
    .map(
      (child) => {
        const childTyped = child as React.ReactElement;
        if (childTyped.type === AccountsDropDownOption) return childTyped;

        return React.cloneElement(
          childTyped,
          {
            // eslint-disable-next-line i18next/no-literal-string
            'data-stable-name': 'AccountsDropDownItem',
            onClick: () => { onSelect(childTyped.props.value); },
          },
        );
      },
    );

  return (
    <>
      { name && (
        <div
          data-stable-name="AccountsDropDownGroupHeaderText"
          className={styles.groupTitle}
        >
          <span>{name}</span>
        </div>
      )}

      <div>
        { cloned.length > 0 && cloned }
        { cloned.length === 0 && <AccountsDropDownEmpty />}
      </div>
    </>
  );
};
